import {
  CONSIGNMENT,
  DROP_SHIP,
  NIKE_DOT_COM,
  NMP,
  NMP_WHOLESALE,
  NSO,
  NSP,
  NSP_WHOLESALE,
  NSP_HYBRID,
  NVS,
} from "../routes";

export const REACT_URL =
  process.env.REACT_APP_FRONTEND_URL ??
  "https://aplas2p-dev.apla-platform-test.nikecloud.com";
export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ??
  "https://aplas2p-dev.apla-platform-test.nikecloud.com";
export const IS_OKTA_QA: boolean = process.env.REACT_APP_IS_OKTA_QA === "true";
export const IGNORE_SUBMISSION_WINDOW: boolean = process.env.REACT_APP_IGNORE_SUBMISSION_WINDOW === "true";

export const COPY_PASTE_SPLIT = /\\r\\n|\r\n|\r|\n/;

export const BE_TO_FE_VALUES = {
  NMP: "Nike Marketplace Partners",
  NMP_PRICE: "Nike Marketplace Partners - Whlse Amt",
  NSP: "Nike Store Partners",
  NSP_PRICE: "Nike Store Partners - Whlse Amt",
  NSO_OWNED: "Nike Store Owned",
  NVS: "Nike Value Store",
  NSP_HYBRID: "Nike Store Partners Hybrid",
  "NIKE.COM": "Nike.com",
  "3PP_DROP_SHIP": "3PP Drop Ship",
  "3PP_CONSIGN": "3PP Consignment",
  FLPKRT: "Flipkart Internet",
  ZOZO: "Zozo",
  RKTN: "Rakuten",
  MERLIB: "Mercado Libre",
  LAZADA: "Lazada",
  MYNTRA: "Myntra",
  MUS: "Musinsa",
};

export const FE_TO_BE_VALUES = Object.entries(BE_TO_FE_VALUES).reduce(
  (acc, [key, value]) => {
    return { ...acc, [value]: key };
  },
  {},
);
export const ROUTE_TO_FE_VALUE = {
  [NMP]: BE_TO_FE_VALUES.NMP,
  [NMP_WHOLESALE]: BE_TO_FE_VALUES.NMP_PRICE,
  [NSP]: BE_TO_FE_VALUES.NSP,
  [NSP_WHOLESALE]: BE_TO_FE_VALUES.NSP_PRICE,
  [NSO]: BE_TO_FE_VALUES.NSO_OWNED,
  [NSP_HYBRID]: BE_TO_FE_VALUES.NSP_HYBRID,
  [NVS]: BE_TO_FE_VALUES.NVS,
  [NIKE_DOT_COM]: BE_TO_FE_VALUES["NIKE.COM"],
  [CONSIGNMENT]: BE_TO_FE_VALUES["3PP_CONSIGN"],
  [DROP_SHIP]: BE_TO_FE_VALUES["3PP_DROP_SHIP"],
};

export const ROUTE_TO_TASK_STATUS_RESPONSE = {
  [NMP]: "NMP",
  [NMP_WHOLESALE]: "NMP_PRICE",
  [NSP]: "NSP",
  [NSP_WHOLESALE]: "NSP_PRICE",
  [NSO]: "NSO_OWNED",
  [NSP_HYBRID]: "NSP_HYBRID",
  [NVS]: "NVS",
  [NIKE_DOT_COM]: "NIKE.COM",
  [CONSIGNMENT]: "3PP_CONSIGN",
  [DROP_SHIP]: "3PP_DROP_SHIP",
};

export const VERTICAL_MONTH_COUNT = 24;
export const TAB_TO_PRODUCT_ENGINE = {
  fw: "FOOTWEAR",
  ap: "APPAREL",
  eq: "EQUIPMENT",
  tb: "TOTAL_BUSINESS",
};
